import type { RouteObject } from "react-router-dom";

import { AddConnectionScreen } from "./AddConnectionScreen";
import { ConnectScreen } from "./ConnectScreen";
import { HmrcConsentForm } from "./HmrcConsentForm";

// Discovered by 06b's `router.tsx`, which globs `./screens/*/routes.tsx`. Absolute paths (§B1.3).
// (The glob pattern is written in a line comment on purpose: inside a `/** … */` block its `*/` would close
// the comment early and the file would not parse.)
//
// The two OAuth return pages (`/oauth/xero/return`, `/oauth/hmrc/return`) are NOT here: the redesign draws
// them chrome-less (XeroOrg.html), so `router.tsx` mounts them under `RequireSession` but outside
// `RootLayout`.
export const routes: RouteObject[] = [
  { path: "/migrations/new", element: <ConnectScreen /> },
  // §P2: the standalone "Add connection" flow off `/connections`, independent of any one migration.
  { path: "/connections/add", element: <AddConnectionScreen /> },
  // DECISIONS-3-v7 §G5.3, §Z item 49, R-20.15. Task 17 builds HmrcConsentForm; this line is what makes it
  // reachable at all - a screen that is reachable before start_hmrc_consent/complete_hmrc_consent exist is
  // a console 404, so it lands in the same commit as the two include_router lines and the msw rows.
  { path: "/migrations/:migrationId/connect/hmrc", element: <HmrcConsentForm /> },
];
